import React from "react";
import { useTranslation } from "react-i18next";

export default function DesktopMenu(props) {
    const { t } = useTranslation();

    const { setStepByIndex, completeSteps, partIndex, partList, currentPart } = props;

    const selectedStepIndex = partIndex(currentPart);

    return (
        <div className="wizard-desktop-menu">
            <div>
                {partList?.map((step, index) => (
                    <div
                        className={`wizard-desktop-menu-item ${completeSteps[index]?.fullfilled ? "completed" : ""} ${
                            selectedStepIndex === index ? "selected" : ""
                        }`}
                        key={step.key}
                        data-index={index}
                        data-step-name={step.menuKey}
                        onClick={() => setStepByIndex(index)}
                    >
                        {t(`${step.menuKey}`)}
                    </div>
                ))}
            </div>
        </div>
    );
}
